import { Reducer } from 'redux';
import { TicketRatesDiscount } from '../../types/property';
import {
  SET_LATITUDE,
  SET_LONGITUDE,
  SET_TRESHOLD_DISCOUNT,
  changeLongitude,
  changeLatitude,
  changeAddress,
  SET_ADDRESS,
  setMark,
  SET_MARK,
  REMOVE_MARK,
  removeMark,
  setTresholdDiscount,
  setGalleryFiles,
  SET_GALLERY_FILES,
  SET_GALLERY_FILES_MOBILE,
  SET_DISCOUNT,
  setDiscount,
  setFreeTickets,
  SET_FREE_TICKETS,
  SET_TICKETS_BUNDLES,
  setTicketsBundles,
  setOtherLandingData,
  SET_OTHER_LANDING_DATA,
  SET_EMAIL_GALLERY_FILE,
  setEmailGalleryFile,
} from '../actions/propertyActions';

type Action =
  | ReturnType<typeof changeLongitude>
  | ReturnType<typeof changeLatitude>
  | ReturnType<typeof changeAddress>
  | ReturnType<typeof setMark>
  | ReturnType<typeof removeMark>
  | ReturnType<typeof setTresholdDiscount>
  | ReturnType<typeof setGalleryFiles>
  | ReturnType<typeof setDiscount>
  | ReturnType<typeof setFreeTickets>
  | ReturnType<typeof setOtherLandingData>
  | ReturnType<typeof setTicketsBundles>
  | ReturnType<typeof setEmailGalleryFile>
  | { type: 'OTHER_ACTION'; payload?: any };

const initialState = {
  latitude: parseFloat(process.env.REACT_APP_LATITUDE || ''),
  longitude: parseFloat(process.env.REACT_APP_LONGITUDE || ''),
  adress: '',
  isNew: false,
  discountRates: Array<TicketRatesDiscount>(),
  ticketDiscount: {},
  galleryFilesMobile: Array<File>(),
  galleryFiles: Array<File>(),
  freeTickets: { freeTicketsRates: [], isActive: false },
  otherData: { name: '', landingType: '', ticketsBundles: [] },
  ticketsBounds: { bundleTickets: [] },
};
const propertyReducer: Reducer<any, Action> = (
  previousState = initialState,
  action
) => {
  if (action.type === SET_LONGITUDE) {
    previousState.longitude = action.payload;
    return previousState;
  }
  if (action.type === SET_LATITUDE) {
    previousState.latitude = action.payload;
    return previousState;
  }
  if (action.type === SET_ADDRESS) {
    previousState.adress = action.payload;
    return previousState;
  }
  if (action.type === SET_MARK) {
    previousState.isNew = true;
    return previousState;
  }
  if (action.type === REMOVE_MARK) {
    previousState.isNew = false;
  }
  if (action.type === SET_TRESHOLD_DISCOUNT) {
    previousState.discountRates = action.payload;
  }
  if (action.type === SET_DISCOUNT) {
    previousState.ticketDiscount = action.payload;
  }
  // if (action.type === SET_GALLERY_IMAGES) {
  //   previousState.galleryImages = action.payload
  // }
  // if (action.type === SET_GALLERY_IMAGES_MOBILE) {
  //   previousState.galleryImagesMobile = action.payload
  // }
  if (action.type === SET_GALLERY_FILES) {
    previousState.galleryFiles = action.payload;
  }
  if (action.type === SET_GALLERY_FILES_MOBILE) {
    previousState.galleryFilesMobile = action.payload;
  }
  if (action.type === SET_EMAIL_GALLERY_FILE) {
    previousState.emailGalleryImage = action.payload;
  }
  if (action.type === SET_FREE_TICKETS) {
    previousState.freeTickets = action.payload;
  }
  if (action.type === SET_OTHER_LANDING_DATA) {
    previousState.otherData = action.payload;
  }
  if (action.type === SET_TICKETS_BUNDLES) {
    previousState.ticketsBounds = action.payload;
  }
  return previousState;
};

export default propertyReducer;
